<template>
    <div class="tkank-note">
        <giveawayModal :settings="giveawayModalSettings"></giveawayModal>
        <div class="logo">
            <img alt="logo" src="@/assets/icons/logo_mini.svg" class="bad">
        </div>
        <profileIcon></profileIcon>
        <div class="place">
            <div class="place_img" @click="onPlaceImageClick()">
                <img v-if="place_img.length != 0" :src="place_img" alt="place img">
                <img v-else src="@/assets/re/default_place_img.jpg" alt="place img">
            </div>
            <div class="place_name" @click="onPlaceNameClick()">{{place_info.place.name}}</div>
        </div>
        <div class="question" @click="onQuestionNameClick">{{place_info.question}}</div>

        <p class="thank-title-1">{{translate('thankVoteTitle1')}}!</p>
        <p class="thank-title-2">
            <span>{{translate('thankVoteTitle2_1')}}!</span>
        </p>

        <socialReviewBtnFlow :settings="socialReviewBtnFlowSettings" class="socialReviewBtnFlow"></socialReviewBtnFlow>
        <giveawayBottomBlock :settings="giveawayBottomBlockSettings" class="giveawayBottomBlock"></giveawayBottomBlock>
        <div class="change_language">
            <languageSwitcher></languageSwitcher>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex';
    import rateMixin from '@/mixins/rateMixin';
    import errorMixin from '@/mixins/errorMixin';
    import logAnalyticsEvent from '@/helpers/analytics'
    import {isValidUrl} from '@/helpers/customValidators'
    import giveawayBottomBlock from "../widgets/giveawayBottomBlock";
    import giveawayModal from "../widgets/giveawayModal";
    import profileIcon from "../voteFlow/widgets/profileIcon.vue";
    import socialReviewBtnFlow from "../voteFlow/widgets/socialReviewBtnFlow.vue";
    import languageSwitcher from '@/components/widgets/languageSwitcher'

    export default {
        name: 'ThanksCreateNote',
        components: {languageSwitcher, giveawayModal, giveawayBottomBlock, profileIcon, socialReviewBtnFlow},
        mixins: [mixin, errorMixin, rateMixin],

        data() {
            return {
                place_img: '',
                place_info: {
                    place: {
                        name: '',
                    },
                    question: ''
                },
                socialModal: false,
                rate_id: this.$route.params.number,
                giveawayModalSettings: null,
                giveawayBottomBlockSettings: {
                    openGiveawayModal: this.showGiveawayPopup.bind(null)
                },
                socialReviewBtnFlowSettings: {},
            }
        },
        watch: {
            isAuthorized(newValue) {
                if (!newValue) {
                    this.$store.commit('rate/clearGiveaway')
                }
            },
            'rate_id'(newValue) {
                this.$store.commit('rate/setRateValue', newValue)
            },
        },
        computed: {
            ...mapState({
                accessToken: state => state.auth.accessToken,
            }),
            ...mapGetters({
                giveaway: 'rate/getGiveaway',
                isAuthorized: 'auth/isAuthorized',
            }),
        },
        methods: {
            ...mapActions({
                sendSocialClick: 'rate/sendSocialClick',
            }),

            onPlaceNameClick() {
                logAnalyticsEvent('thx_vote_screen_place_title_click')
                this.openSiteUrl()
            },

            onPlaceImageClick() {
                logAnalyticsEvent('thx_vote_screen_place_img_click')
                this.openSiteUrl()
            },

            openSiteUrl() {
                let url = this.place_info.place.site_url
                if (isValidUrl(url)) {
                    window.open(url, '_blank')
                }
            },

            onQuestionNameClick() {
                logAnalyticsEvent('thx_vote_screen_question_title_click')
            },

            showGiveawayPopup() {
                this.giveawayModalSettings = {
                    showCancelButton: false,
                    hideOkButton: true,
                    place_info: this.place_info,
                    currentVoteUid: this.$route.params.rateUid,
                    question_id: this.$route.params.questionId,
                }
            },

        },
        async mounted() {
            this.getRateInfo(this.$route.params.questionId)
            this.$store.commit('rate/setRateValue', this.$route.params.number)
            this.$store.commit('rate/setRateUid', this.$route.params.rateUid)
        }
    }
</script>

<style scoped>

    .socialReviewBtnFlow {
        margin-bottom: 10px;
    }
    .change_language {
        position: absolute;
    }

    .list-view {
        background: #2F2F2F;
        border-radius: 0;
        font-size: 1.1em;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.7em;
    }

    .list-view span {
        margin-right: .4em;
        line-height: normal;
    }

    .tkank-note {
        /*height: 100vh;*/
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        flex: 1 1;
        overflow: auto;
    }

    .logo {
        margin-top: 1em;
        text-align: center;
        margin-bottom: 15px;
    }

    .place {
        /*flex: 1 1 40%;*/
    }

    .place_img {
        width: 6em;
        height: 6em;
        margin: 1em auto 1em;
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 0px 0px 0px 6px #fff, 0px 0px 7px 3px #555;
    }

    .place_img img {
        min-width: 6em;
        min-height: 6em;
        margin: 0 auto;
        display: block;
        width: 100%;
        height: 100%;
    }

    .question{
        text-align: center;
        font-size: 1.2em;
        font-weight: 700;
        margin-right: 20px;
        margin-left: 20px;
    }
    .place_name {
        text-align: center;
        font-size: 1.2em;
        margin-right: 20px;
        margin-left: 20px;
    }

    .thank-title-1 {
        font-size: 14px;
        font-weight: 700;
        text-align: center;
    }

    .thank-title-2 {
        font-size: 16px;
        text-align: center;
    }

    .thank-title-2 span {
        display: block;
    }


    .button-group-login {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .button-group-login button {
        padding: 0.5em 0.7em;
        margin: 0 0.5em .5em;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 0;
        color: #fff;
    }

    .button-group-login button.google {
        background: #DD4B39;
    }

    .button-group-login button.facebook {
        background: #1976D2;
    }

    .button-group-login button img {
        margin-right: .2em;
    }

    .push_rate ul li.active.cool {
        box-shadow: inset 0 0 0 0.35em #209400
    }

    .push_rate ul li.active.soso {
        box-shadow: inset 0 0 0 0.35em #ffc800
    }

    .push_rate ul li.active.meh {
        box-shadow: inset 0 0 0 0.35em #e01300
    }

</style>